import { map } from "./image-map.js";

export const categories = [
  ...map,
];
